import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      const hash = window.location.hash;
      const params = new URLSearchParams(hash.replace('#', ''));
      const sessionId = params.get('session_id');

      if (!sessionId) {
        navigate('/admin/login');
        return;
      }

      try {
        const response = await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        setUser(response.data.user);
        // Clean URL and redirect
        window.history.replaceState({}, document.title, window.location.pathname);
        navigate('/admin', { state: { user: response.data.user }, replace: true });
      } catch (error) {
        console.error('Auth error:', error);
        navigate('/admin/login', { replace: true });
      }
    };

    processSession();
  }, [navigate, setUser]);

  return (
    <div data-testid="auth-callback" className="min-h-screen flex items-center justify-center bg-[#F9F6F0]">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#2C5263] mx-auto mb-4"></div>
        <p className="text-[#666666]">Autenticazione in corso...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
